import { mergeRefs } from '@react-aria/utils'
import cx from 'classnames'
import { forwardRef } from 'react'

import * as styles from './Scroller.css'

const Scroller = forwardRef(
  (
    { children, className, context, ...props }: any,
    outerRef: React.ForwardedRef<HTMLDivElement>,
  ) => {
    /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument -- FIXME: Fix this ESLint violation! */
    const ref = mergeRefs(outerRef, context.controller.scrollerRef)

    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- FIXME: Fix this ESLint violation!
      <div {...props} ref={ref} className={cx(styles.root, className)}>
        {children}
      </div>
    )
  },
)

export default Scroller
